import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import community from "../../../assets/icons/community.png";
import science from "../../../assets/icons/science.png";
import nature from "../../../assets/icons/nature.png";
import sustainability from "../../../assets/icons/sustainability.png";
import learning from "../../../assets/icons/learning.png";
import policies from "../../../assets/icons/policies.png";
import alliance from "../../../assets/icons/alliance.png";

const HowWeWork = () => {
  return (
    <Box margin={{ xs: "25% 4% 4% 4%", sm: "5% 0%" }}>
      <Typography
        variant="h3"
        fontWeight={700}
        padding={{ xs: "0% 0% 4% 0%", sm: "0% 2% 2% 2%" }}
        textAlign={"left"}
        color={"#9DCC49"}
      >
        {" "}
        How We Work
      </Typography>
      <Typography
        variant="h6"
        color="#000"
        fontWeight={400}
        padding={"0% 2% 2% 2%"}
        textAlign={"left"}
      >
        Blue Echo Foundation delivers impact through an integrated,
        partnership-driven model that connects ecosystem protection with
        community livelihoods, policy reform, and long-term sustainability.
      </Typography>
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        flexWrap={"wrap"}
        width={{ xs: "100%", sm: "100%" }}
      >
        <Box
          padding={{ xs: "5%", sm: "2%" }}
          width={{ xs: "100%", sm: "33%" }}
          display={"flex"}
          justifyContent={"space-between"}
          flexWrap={"wrap"}
        >
          <Box marginTop={"15%"} width={{ xs: "35%", sm: "20%" }}>
            <Box
              component="img"
              height={{ xs: "104px", sm: "11vh" }}
              sx={{
                objectFit: "cover",
                overflow: "hidden",
                width: "100%",
              }}
              src={community}
              alt={"icons"}
            />
          </Box>
          <Box width={{ xs: "100%", sm: "75%" }}>
            <Typography
              variant="h5"
              color="#000"
              fontWeight={700}
              paddingTop={"10%"}
              paddingBottom={"2%"}
              textAlign={"left"}
            >
              Community-Led Solutions
            </Typography>
            <Typography
              variant="body1"
              color="#000"
              fontWeight={400}
              paddingTop={"4%"}
              paddingBottom={"2%"}
              lineHeight={1.5}
              textAlign={"left"}
            >
              We work directly with coastal communities as co-designers and
              co-managers of interventions. Local knowledge, traditional
              practices, and lived experience guide how restoration, fisheries
              management, and livelihood programs are designed and implemented.
              This ensures ownership, relevance, and long-term impact.
            </Typography>
          </Box>
        </Box>
        <Box
          padding={{ xs: "5%", sm: " 2%" }}
          width={{ xs: "100%", sm: "33%" }}
          display={"flex"}
          justifyContent={"space-between"}
          flexWrap={"wrap"}
        >
          <Box marginTop={"15%"} width={{ xs: "35%", sm: "20%" }}>
            <Box
              component="img"
              height={{ xs: "104px", sm: "11vh" }}
              sx={{
                objectFit: "cover",
                overflow: "hidden",
                width: "100%",
              }}
              src={science}
              alt={"icons"}
            />
          </Box>
          <Box width={{ xs: "100%", sm: "75%" }}>
            <Typography
              variant="h5"
              color="#000"
              fontWeight={700}
              paddingTop={"10%"}
              paddingBottom={"2%"}
              textAlign={"left"}
            >
              Science-Based and Data-Driven
            </Typography>
            <Typography
              variant="body1"
              color="#000"
              fontWeight={400}
              paddingTop={"4%"}
              paddingBottom={"2%"}
              lineHeight={1.5}
              textAlign={"left"}
            >
              Our programs are grounded in marine science, applied research, and
              continuous monitoring. We generate and use data on biodiversity,
              water quality, coastal erosion, fisheries stocks, and climate
              risks to inform decision-making, improve accountability, and
              support evidence-based policy reform.
            </Typography>
          </Box>
        </Box>
        <Box
          padding={{ xs: "5%", sm: "2%" }}
          width={{ xs: "100%", sm: "33%" }}
          display={"flex"}
          justifyContent={"space-between"}
          flexWrap={"wrap"}
        >
          <Box marginTop={"15%"} width={{ xs: "35%", sm: "20%" }}>
            <Box
              component="img"
              height={{ xs: "104px", sm: "11vh" }}
              sx={{
                objectFit: "cover",
                overflow: "hidden",
                width: "100%",
              }}
              src={nature}
              alt={"icons"}
            />
          </Box>
          <Box width={{ xs: "100%", sm: "75%" }}>
            <Typography
              variant="h5"
              color="#000"
              fontWeight={700}
              paddingTop={"10%"}
              paddingBottom={"2%"}
              textAlign={"left"}
            >
              Nature-Based and Climate-Smart
            </Typography>
            <Typography
              variant="body1"
              color="#000"
              fontWeight={400}
              paddingTop={"4%"}
              paddingBottom={"2%"}
              lineHeight={1.5}
              textAlign={"left"}
            >
              We prioritize nature-based solutions that protect ecosystems while
              strengthening resilience to climate change. Mangrove restoration,
              oyster reefs, shoreline stabilization, and blue carbon approaches
              are deployed to reduce erosion, enhance biodiversity, and
              safeguard coastal settlements and infrastructure.
            </Typography>
          </Box>
        </Box>
        <Box
          padding={{ xs: "5%", sm: " 2%" }}
          width={{ xs: "100%", sm: "33%" }}
          display={"flex"}
          justifyContent={"space-between"}
          flexWrap={"wrap"}
        >
          <Box marginTop={"15%"} width={{ xs: "35%", sm: "20%" }}>
            <Box
              component="img"
              height={{ xs: "104px", sm: "11vh" }}
              sx={{
                objectFit: "cover",
                overflow: "hidden",
                width: "100%",
              }}
              src={sustainability}
              alt={"icons"}
            />
          </Box>
          <Box width={{ xs: "100%", sm: "75%" }}>
            <Typography
              variant="h5"
              color="#000"
              fontWeight={700}
              paddingTop={"10%"}
              paddingBottom={"2%"}
              textAlign={"left"}
            >
              Livelihood-Focused and Inclusive
            </Typography>
            <Typography
              variant="body1"
              color="#000"
              fontWeight={400}
              paddingTop={"4%"}
              paddingBottom={"2%"}
              lineHeight={1.5}
              textAlign={"left"}
            >
              Environmental sustainability must deliver economic value. We
              support sustainable fisheries, aquaculture, processing, and
              coastal enterprises that increase income while reducing pressure
              on ecosystems. Women and youth are central to our programs, with
              targeted access to skills, finance, and markets.
            </Typography>
          </Box>
        </Box>
        <Box
          padding={{ xs: "5%", sm: " 2%" }}
          width={{ xs: "100%", sm: "33%" }}
          display={"flex"}
          justifyContent={"space-between"}
          flexWrap={"wrap"}
        >
          <Box marginTop={"15%"} width={{ xs: "35%", sm: "20%" }}>
            <Box
              component="img"
              height={{ xs: "104px", sm: "11vh" }}
              sx={{
                objectFit: "cover",
                overflow: "hidden",
                width: "100%",
              }}
              src={alliance}
              alt={"icons"}
            />
          </Box>
          <Box width={{ xs: "100%", sm: "75%" }}>
            <Typography
              variant="h5"
              color="#000"
              fontWeight={700}
              paddingTop={"10%"}
              paddingBottom={"2%"}
              textAlign={"left"}
            >
              Partnership-Driven
            </Typography>
            <Typography
              variant="body1"
              color="#000"
              fontWeight={400}
              paddingTop={"4%"}
              paddingBottom={"2%"}
              lineHeight={1.5}
              textAlign={"left"}
            >
              We collaborate with government agencies, research institutions,
              development partners, civil society, and the private sector. By
              aligning public policy, community action, and responsible
              investment, we help scale solutions that individual actors cannot
              deliver alone.
            </Typography>
          </Box>
        </Box>
        <Box
          padding={{ xs: "5%", sm: "2%" }}
          width={{ xs: "100%", sm: "33%" }}
          display={"flex"}
          justifyContent={"space-between"}
          flexWrap={"wrap"}
        >
          <Box marginTop={"15%"} width={{ xs: "35%", sm: "20%" }}>
            <Box
              component="img"
              height={{ xs: "104px", sm: "11vh" }}
              sx={{
                objectFit: "cover",
                overflow: "hidden",
                width: "100%",
              }}
              src={policies}
              alt={"icons"}
            />
          </Box>
          <Box width={{ xs: "100%", sm: "75%" }}>
            <Typography
              variant="h5"
              color="#000"
              fontWeight={700}
              paddingTop={"10%"}
              paddingBottom={"2%"}
              textAlign={"left"}
            >
              Policy and Systems Change
            </Typography>
            <Typography
              variant="body1"
              color="#000"
              fontWeight={400}
              paddingTop={"4%"}
              paddingBottom={"2%"}
              lineHeight={1.5}
              textAlign={"left"}
            >
              Beyond projects, we engage in policy dialogue and advocacy to
              strengthen marine and coastal governance in Nigeria. We support
              marine spatial planning, climate adaptation strategies, and blue
              economy frameworks that enable sustainable development at scale.
            </Typography>
          </Box>
        </Box>
      </Box>
      <Box display={"flex"} justifyContent={"center"}>
        <Box
          padding={{ xs: "5%", sm: "0% 2% 5% 2%" }}
          width={{ xs: "100%", sm: "33%" }}
          display={"flex"}
          justifyContent={"space-between"}
          flexWrap={"wrap"}
        >
          <Box marginTop={"15%"} width={{ xs: "35%", sm: "20%" }}>
            <Box
              component="img"
              height={{ xs: "104px", sm: "11vh" }}
              sx={{
                objectFit: "cover",
                overflow: "hidden",
                width: "100%",
              }}
              src={learning}
              alt={"icons"}
            />
          </Box>
          <Box width={{ xs: "100%", sm: "75%" }}>
            <Typography
              variant="h5"
              color="#000"
              fontWeight={700}
              paddingTop={"10%"}
              paddingBottom={"2%"}
              textAlign={"left"}
            >
              Learning and Adaptation
            </Typography>
            <Typography
              variant="body1"
              color="#000"
              fontWeight={400}
              paddingTop={"4%"}
              paddingBottom={"2%"}
              lineHeight={1.5}
              textAlign={"left"}
            >
              We treat every intervention as a learning opportunity. Continuous
              feedback, monitoring, and evaluation allow us to adapt programs to
              changing ecological, social, and climate conditions, ensuring
              effectiveness in Nigeria’s dynamic coastal environments.
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default HowWeWork;
